(function ($) {
    "use strict";

}(jQuery));
